"use client";

import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import { useMemo } from "react";

const HomeBannerSectionFormFields = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  handleTextEditorInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isNonTranslatableField = useMemo(() => {
    return activeLang === "en" ? true : false;
  }, [activeLang]);

  const getSelectedBannerImageId = (id) => {
    if (id) {
      onChangeImage("home-section-1-banner-image", id);
    } else {
      onChangeImage("home-section-1-banner-image", "");
    }
  };

  return (
    <>
      {/* Banner Image */}
      {isNonTranslatableField && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Banner Image"
          fieldId="home-section-1-banner-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getSelectedBannerImageId}
          selectedFileId={stateDetails?.["home-section-1-banner-image"] || ""}
          adminRole={adminRole}
          permissionsList={permissionsList}
          infoText="Recommended size: 1300 x 650px"
          extraContainerClasses="mb-5"
        />
      )}

      {/* Banner Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-1-banner-heading"
        fieldName="home-section-1-banner-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-1-banner-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />

      {/* Banner Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Sub Heading"
        fieldId="home-section-1-banner-sub-heading"
        fieldName="home-section-1-banner-sub-heading"
        placeholderText="Sub Heading"
        inputValue={stateDetails?.["home-section-1-banner-sub-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Description */}
      <NormalTextEditorInputFiled
        isFetching={isFetching}
        labelText="Description"
        fieldId="home-section-1-banner-description"
        fieldName="home-section-1-banner-description"
        placeholderText="Description"
        inputValue={stateDetails?.["home-section-1-banner-description"] || ""}
        onChangeTextEditorFiled={handleTextEditorInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />

      {/* Button Label */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Button Label"
        fieldId="home-section-1-banner-button-label"
        fieldName="home-section-1-banner-button-label"
        placeholderText="Label Name"
        inputValue={stateDetails?.["home-section-1-banner-button-label"] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />
    </>
  );
};

export default HomeBannerSectionFormFields;
